/** @deprecated */
export const ERROR_GUIDS: { [key: string]: string } = {
	GUID_3efdebe4129f4b97923f93729b4185d1: 'Core/Error.GUID.3efdebe4129f4b97923f93729b4185d1',
	GUID_aeced4e7935e4ad7b7033a00cae7ce52: 'Core/Error.GUID.aeced4e7935e4ad7b7033a00cae7ce52',
	GUID_281712bdc76e45578c1972c59dc8e7b3:
		'CandidateProfile.PrimaryInformation.Affiliation/Error.GUID.281712bdc76e45578c1972c59dc8e7b3',
	GUID_e70f817b343c4d01adb10c9b8f803a34:
		'CandidateProfile.PrimaryInformation.Affiliation/Error.GUID.e70f817b343c4d01adb10c9b8f803a34',
	GUID_200b93db5da24725a93098c4f6b08046:
		'CandidateProfile.PrimaryInformation.Affiliation/Error.GUID.200b93db5da24725a93098c4f6b08046',
	GUID_4f7e9e7703f14f6ba05e75eb6df88d31:
		'CandidateProfile.PrimaryInformation.Affiliation/Error.GUID.4f7e9e7703f14f6ba05e75eb6df88d31',
	GUID_a0c6448e32a54e2cbceeed388615c97b:
		'CandidateProfile.PrimaryInformation.Affiliation/Error.GUID.a0c6448e32a54e2cbceeed388615c97b',
	GUID_03378066bf6b4860b7aba4d5e7573314:
		'CandidateProfile.PrimaryInformation.Affiliation/Error.GUID.03378066bf6b4860b7aba4d5e7573314',
	GUID_669b087c7a4149b881d8b3142cbfebcf:
		'CandidateProfile.PrimaryInformation.Affiliation/Error.GUID.669b087c7a4149b881d8b3142cbfebcf',
	GUID_10a781939f3e45cb8ee9631831486ab3:
		'CandidateProfile.PrimaryInformation.Affiliation/Error.GUID.10a781939f3e45cb8ee9631831486ab3',
	GUID_cb675a646f874433a644c31bb6bd1357:
		'CandidateProfile.PrimaryInformation.Affiliation/Error.GUID.cb675a646f874433a644c31bb6bd1357',
	GUID_af3d920b1ebf483bb75c112920ea4203:
		'CandidateProfile.PrimaryInformation.Affiliation/Error.GUID.af3d920b1ebf483bb75c112920ea4203',
	GUID_d1a77c8c9c824cb891fec6b77d9012d8:
		'CandidateProfile.PrimaryInformation.Affiliation/Error.GUID.d1a77c8c9c824cb891fec6b77d9012d8',
	GUID_4713a092237041b6ba861ff284a95a00: 'Tagging/Error.GUID.4713a092237041b6ba861ff284a95a00',
	GUID_730835942eb245fca93279e688ff42b1: 'Core/Error.GUID.730835942eb245fca93279e688ff42b1',
	GUID_3917904bbd174c6989da28ecf48465dc: 'Core/Error.GUID.3917904bbd174c6989da28ecf48465dc',
	GUID_181ff1f2712840b9a1c51df0e89f781d: 'Core/Error.GUID.181ff1f2712840b9a1c51df0e89f781d',
	GUID_360836083bb0429b938d2e6da2703a39: 'Core/Error.GUID.360836083bb0429b938d2e6da2703a39',
	GUID_5279dca9b5b848aeb3034332646067fc: 'Core/Error.GUID.5279dca9b5b848aeb3034332646067fc',
	GUID_0ad817d9b202419eb25ba2a93430be83: 'Core/System.Global.Notification.NoChanges',
	GUID_949807cca5a84dfe85c9456cc45548b4: 'Core/Error.GUID.949807cca5a84dfe85c9456cc45548b4',
	GUID_31de40b13ee5464f92f4baef09c189ce: 'Core/Error.GUID.949807cca5a84dfe85c9456cc45548b4',
	GUID_3ec0ba6614824d739ecfe5daf13db583:
		'UserTwoStepAuthentication/Error.GUID.3ec0ba6614824d739ecfe5daf13db583',
	GUID_c71d8e61c5d94d35bf47bdb7a7d210e1: 'Core/Error.GUID.c71d8e61c5d94d35bf47bdb7a7d210e1',
	GUID_7fab0f358b504243be0c14d317806ff5: 'Core/Error.GUID.7fab0f358b504243be0c14d317806ff5',
	GUID_082741d7073c409880e4e4aaf4a2ff11: 'Core/Error.GUID.082741d7073c409880e4e4aaf4a2ff11',
	GUID_3d9f264260c342038fbc9061c8bf0c57: 'Exam/Error.GUID.3d9f264260c342038fbc9061c8bf0c57',
	GUID_8d55c522ad13470cb4f46f453dd9bf0a: 'Exam/Error.GUID.8d55c522ad13470cb4f46f453dd9bf0a',
	GUID_0938d22c550b40b990ace5d9ed81c494: 'Core/Error.GUID.0938d22c550b40b990ace5d9ed81c494',
	GUID_3c3f102afd144114bd6a72752c83c7a3: 'Core/Error.GUID.3c3f102afd144114bd6a72752c83c7a3',
	GUID_71d535637b834d2fb94ffe06251c75e1: 'Core/Error.GUID.71d535637b834d2fb94ffe06251c75e1',
	GUID_506eff69d94442a7a63ffe60261f3bc8:
		'CandidateAccess.Login/Error.GUID.506eff69d94442a7a63ffe60261f3bc8',
	GUID_a6b433ba53ea44f2981e3fae44851ffc:
		'CandidateAccess.Login/Error.GUID.a6b433ba53ea44f2981e3fae44851ffc',
	GUID_5f105fdce3f945e8a49e8d384cb834f5: 'Core/Error.GUID.SystemError',
	GUID_11945915d3eb4a03b55a4ec74110a92e: 'Core/Error.GUID.SystemError',
	GUID_4ab87866d4fc4beb9e55c3c76e9ad9ba: 'Core/Error.GUID.SystemError',
	GUID_a900daccb95746f886cc659230f6808c: 'Core/Error.GUID.SystemError',
	GUID_e4ee4ab7edc246be80977fbc07dcd1f4: 'Core/Error.GUID.TryAgain',
	GUID_499ed929ea6f4e218b4be0a487de7ec2: 'Core/Error.GUID.TryAgain',
	GUID_ff685f2ec5f04ce1aa14828f8744755c: 'Core/Error.GUID.TryAgain',
	GUID_4755b2563eaa424dbef5a7a85784a0ab: 'Core/Error.GUID.TryAgain',
	GUID_51de9a1420294b6b9672baa2d9305cd7: 'Core/Error.GUID.TryAgain',
	GUID_6bdd6e29b47c4ddebbb4bac5a7dd2c0f: 'Core/Error.GUID.TryAgain',
	GUID_79a96d9aff604b488b61c4e30866c5bb: 'Core/Error.GUID.TryAgain',
	GUID_71147c55ba4340089f613ecc74bbb2d8: 'Core/Error.GUID.TryAgain',
	GUID_ef0e1c2d79574db7bf35e036cd8b6de8: 'Core/Error.GUID.TryAgain',
	GUID_8c9cdfb47178426e9e7a106b8679fc31: 'Core/Error.GUID.TryAgain',
	GUID_0c50e1a4e68045bfaaaa696fab344bdd: 'Core/Error.GUID.TryAgain',
	GUID_5f0afcf740524c2fae9c6b4ebe189c7c: 'Core/Error.GUID.TryAgain',
	GUID_65f3cde1bce74eda9b70e6eef2d40206: 'Core/Error.GUID.TryAgain',
	GUID_9e9cfe42032a43019d9bb390cefc6014: 'Core/Error.GUID.TryAgain',
	GUID_b1832ce32a9f47a49a0dfe3bbe0f7d4f: 'Core/Error.GUID.TryAgain',
	GUID_e4887a240d5d42aab92bfbe6fbc7f991: 'Core/Error.GUID.TryAgain',
	GUID_c271a4ac4b554eea85be315500ef25c3: 'Core/Error.GUID.TryAgain',
	GUID_0a2b32e07d904b159c1f7b274fd10ee9: 'Core/Error.GUID.TryAgain',
	GUID_ab568720e99f4580ac11fa53789d2dc4: 'Core/Error.GUID.TryAgain',
	GUID_553d0f3a2d3f46fc82a9298441eb47ef: 'Core/Error.GUID.TryAgain',
	GUID_394532dcff2e46979ca3eb51267d22fb: 'Core/Error.GUID.TryAgain',
	GUID_e79680922643436bbdbcd570ac9e3340: 'Core/Error.GUID.TryAgain',
	GUID_c8394367a0694a8a8a37b450113dcde2: 'Core/Error.GUID.TryAgain',
	GUID_96ce7b5829bb4d8eb9184a2821feffe4: 'Core/Error.GUID.TryAgain',
	GUID_ba6c3126056842f283e93adb0b98c553: 'Core/Error.GUID.TryAgain',
	GUID_6d27be0634c241eaaeb802b306946d89: 'Core/Error.GUID.TryAgain',
	GUID_4ab47cae6a724d31af6cfd0853269bbd: 'Core/Error.GUID.TryAgain',
	GUID_394191c13dca40f6b5813a1a5be2b45b: 'Core/Error.GUID.TryAgain',
	GUID_3d69668959fb474b809c36b3d0b28e68: 'Core/Error.GUID.TryAgain',
	GUID_3dec766078574db3a73840ac2844dcb9: 'Core/Error.GUID.TryAgain',
	GUID_2668c2795a624cb585dc63ee8e8ed489: 'Core/Error.GUID.TryAgain',
	GUID_51a337944b72436187fd1b7a056f4afc: 'Core/Error.GUID.TryAgain',
	GUID_8a0a0a4d98ed497d8e06369cf0e7e768: 'Core/Error.GUID.TryAgain',
	GUID_d9b40d4ff3cc486caa0bbf1745b3069c: 'Core/Error.GUID.TryAgain',
	GUID_0c6c6c2b2b3046c8a1c44ee3b3e9141e: 'Core/Error.GUID.TryAgain',
	GUID_9c91d86b5f5c4f9cb4ed736c2fdd1aa7: 'Core/Error.GUID.TryAgain',
	GUID_d0d450ba40494d0a88d581498457aa64: 'Core/Error.GUID.TryAgain',
	GUID_116c342509ca4182a291ad3b7b4c55c7: 'Core/Error.GUID.TryAgain',
	GUID_42445bd9e4794e9c9ac05c45ce002892: 'Core/Error.GUID.TryAgain',
	GUID_455a95d9dbe44af1afa37f72884ef062: 'Core/Error.GUID.TryAgain',
	GUID_8644c9bb4f43466fb5e8bb927575a6ec: 'Core/Error.GUID.TryAgain',
	GUID_a187a42c65c04556a3f20246ac30b8d2: 'Core/Error.GUID.UIError',
	GUID_437669c9d77b45f8949bc3b115560324: 'Core/Error.GUID.UIError',
	GUID_7f6ea6dab341412ca68ab9a2825ebc36: 'Core/Error.GUID.UIError',
	GUID_461a6d344d5840398e75b193dc93d71f: 'Core/Error.GUID.UIError',
	GUID_cb15a8a9bb77483cbffbd46939deddbe: 'Core/Error.GUID.UIError',
	GUID_2ccecbf9ee7a4215ab3e41835426f9c6: 'Core/Error.GUID.UIError',
	GUID_8ccadd7ee37e4248b4446f84563a2db5: 'Core/Error.GUID.UIError',
	GUID_01310719cf3e42d281dda8ae52171b68: 'Core/Error.GUID.UIError',
	GUID_98ca214affad4d5f9fccb239a17bf203: 'Core/Error.GUID.UIError',
	GUID_6d429e3c1deb4247af679f9670889ca9: 'Core/Error.GUID.UIError',
	GUID_fc11c94852b94f629f190ad64e4e03ef: 'Core/Error.GUID.UIError',
	GUID_b31325942c8140c9acb4d9b4babbb200: 'Core/Error.GUID.UIError',
	GUID_2dd1b77903224823b7456546ecd90df1: 'Core/Error.GUID.UIError',
	GUID_7b22408e106048db92913fb08dc0c4ae: 'Core/Error.GUID.UIError',
	GUID_1744c1e5d133482da0bcef98fd6498e1: 'Core/Error.GUID.UIError',
	GUID_0485eff4a9004ee6bfc7d081074fa74b: 'Core/Error.GUID.UIError',
	GUID_39b60838239b46cb87b191dcbd45da6f: 'Core/Error.GUID.UIError',
	GUID_edaf945850464f0b9a30426b272d028a: 'Core/Error.GUID.UIError',
	GUID_0ff985d2411c4e1e9aab13cd88dbf63b: 'Core/Error.GUID.UIError',
	GUID_3eacf772d04548b4beeeb2894c64873b: 'Core/Error.GUID.UIError',
	GUID_4d193b2185b54ea0a055d556576a1989: 'Core/Error.GUID.UIError',
	GUID_f966592881424ae98607be4aa5d62265: 'Core/Error.GUID.UIError',
	GUID_c990fff4ca6c44909e7c5d42859caf59: 'Core/Error.GUID.UIError',
	GUID_666067d8880e498abbf7927327fe836f: 'Core/Error.GUID.UIError',
	GUID_99730d2042374f19b19c0297dc37d03f: 'Core/Error.GUID.UIError',
	GUID_b08474f1877f40288e5ddba7f30a6f60: 'Core/Error.GUID.UIError',
	GUID_dec57ec6ec124f67a87513546020f771: 'Core/Error.GUID.UIError',
	GUID_0410dfe5708c449e8c29958ade9208da: 'Core/Error.GUID.UIError',
	GUID_3fccb1b346af4fc0a3161bd7e9a2e17c: 'Core/Error.GUID.UIError',
	GUID_36679acce4134562b4407a17f8516d45: 'Core/Error.GUID.UIError',
	GUID_a8b206a106ad441caaa36d851857985f: 'Core/Error.GUID.UIError',
	GUID_83f919bf184f4ec38259394484e928d0: 'Core/Error.GUID.UIError',
	GUID_3875762cf3654f0d905932d160154fbd: 'Core/Error.GUID.UIError',
	GUID_53f2680248cf4d03993c4b91e3387f9d: 'Core/Error.GUID.UIError',
	GUID_6b553e11f16746b8a34690b5b67f2d1f: 'Core/Error.GUID.UIError',
	GUID_0bb12ef6c3c6400495c161f14d2217e8: 'Core/Error.GUID.UIError',
	GUID_012aacc090774da682df74516f009219: 'Core/Error.GUID.UIError',
	GUID_b061ead98808428c8b655d9e3d29a455: 'Core/Error.GUID.UIError',
	GUID_dfae02d2b02b44389aab84ed7be2f4aa: 'Core/Error.GUID.UIError',
	GUID_2eb57b88e85b45bca4a80fc0c7d5a088: 'Core/Error.GUID.UIError',
	GUID_33c2180859904ab08cdd027687849c5d: 'Core/Error.GUID.UIError',
	GUID_0904472e21df4a06b7f847fe5f5070fe: 'Core/Error.GUID.UIError',
	GUID_459fd41499cd40a3a959639a2da2f92e: 'Core/Error.GUID.UIError',
	GUID_ba687ccb51c248589bcc6a54862ca106: 'Core/Error.GUID.UIError',
	GUID_7f404c37f40246d9a4fb120798d4730e: 'Core/Error.GUID.UIError',
	GUID_7a21b9a627ba4d6bbe553b489541fb31: 'Core/Error.GUID.UIError',
	GUID_c257cba532e14e9e810de2d907179950: 'Core/Error.GUID.UIError',
	GUID_7f2e1e2f140c402193706b2d7d865043: 'Core/Error.GUID.UIError',
	GUID_b0e61d60267d4d64b8bd2701606257f9: 'Core/Error.GUID.UIError',
	GUID_4d54601bca09417b94adfb5aeb216dfe: 'Core/Error.GUID.UIError',
	GUID_50a7ace27b4f4fd4b1dc6ebf4944d063: 'Core/Error.GUID.UIError',
	GUID_a231a66537b94ef3a456c70ebcba1009: 'Core/Error.GUID.UIError',
	GUID_f0ff1fe4a1ec4693affec4cc74ed430b: 'Core/Error.GUID.UIError',
	GUID_2f086fb580ed4641a028b1bc1dd43caf: 'Core/Error.GUID.UIError',
	GUID_15dcab03796547d8a537fb27805edde1: 'Core/Error.GUID.UIError',
	GUID_867de616815d4e18ba89aa0b097e232e: 'Core/Error.GUID.UIError',
	GUID_7d08282e038b41f48c05a864fdafaa4b: 'Core/Error.GUID.UIError',
	GUID_5365b79dbb46409a888993ae39d19594: 'Core/Error.GUID.UIError',
	GUID_c07e15bbdc0e46bb9ce186a618b55fb1: 'Core/Error.GUID.UIError',
	GUID_7be52347260e46fbbdb3a7f80f932b56: 'Core/Error.GUID.UIError',
	GUID_02c136f6eccb455884229f40976bdb4c: 'Core/Error.GUID.UIError',
	GUID_34b91807869d4f0c9eb7ad94cda6896e: 'Core/Error.GUID.UIError',
	GUID_02b2d94bc9d144cd9a693a0d47a0f8aa: 'Core/Error.GUID.UIError',
	GUID_11e517e8ce6a493ea5f35fd0538e2df3: 'Core/Error.GUID.UIError',
	GUID_8355d31d41744ebb892215d68deb52cd: 'Core/Error.GUID.UIError',
	GUID_abcf947ac78d42f6b06c641fab2c5ce6: 'Core/Error.GUID.UIError',
	GUID_b913ce0861d148b69bb5f0d296926fd5: 'Core/Error.GUID.UIError',
	GUID_2930b1735cff4944a76e5fefd9f5e78a: 'Core/Error.GUID.UIError',
	GUID_53fdc362cef948c880f336c65f7d78ce: 'Core/Error.GUID.UIError',
	GUID_7478c4aa45394b4ab9c1858239e76666: 'Core/Error.GUID.UIError',
	GUID_6e620795eb394295bcf99ce1eb510b63: 'Core/Error.GUID.UIError',
	GUID_c8ed113fcdf44b959a14b1a488b50d5a: 'Core/Error.GUID.UIError',
	GUID_7ea9e4ea8795412f94128f6ea76b76b3: 'Core/Error.GUID.UIError',
	GUID_418252a9be5f42be88a997db937628a3: 'Core/Error.GUID.UIError',
	GUID_b0853fd8d2ef44cfb96bbe0403fd311b: 'Core/Error.GUID.UIError',
	GUID_39f7a2ff80ed43589cff8284d4e16560: 'Core/Error.GUID.UIError',
	GUID_4376e248a036418ba7dc00e409cafa8a: 'Core/Error.GUID.UIError',
	GUID_5d011dfcb8d34a02bf0ace50a85fcb9c: 'Core/Error.GUID.UIError',
	GUID_24379a9fb7f242ecb4930da57761ab55: 'Core/Error.GUID.UIError',
	GUID_2236eb45b4fc471c94a7d69bf4901b48: 'Core/Error.GUID.UIError',
	GUID_0cb1b1db207c478782230540c2cea03f: 'Core/Error.GUID.UIError',
	GUID_faf3edb29dac4436b58b013472cada64: 'Core/Error.GUID.UIError',
	GUID_c11c7701f2d145878a42b7c83fd5d3f3: 'Core/Error.GUID.UIError',
	GUID_275b0fc2cb7540018f411114779febeb: 'Core/Error.GUID.UIError',
	GUID_9406ef8e815240d9a4e0a76815eea7ad: 'Core/Error.GUID.UIError',
	GUID_68cd39e8849e417f8c364ccd0390e3ae: 'Core/Error.GUID.UIError',
	GUID_7bf2ddefdc6641a0978dc7db94443e7c:
		'CandidateAccess/Error.GUID.7bf2ddefdc6641a0978dc7db94443e7c',
	GUID_081a212a11974dc3957c1d25db3d9ca3: 'Core/Error.GUID.081a212a11974dc3957c1d25db3d9ca3',
	GUID_07a91aa70facc74ebd1e70cb6686eb02: 'Benefit/Error.GUID.07a91aa70facc74ebd1e70cb6686eb02',
	GUID_da68b68ccfabbab8654d7df9dcd2480b: 'Benefit/Error.GUID.da68b68ccfabbab8654d7df9dcd2480b',
	GUID_2349a3fec05b081e10091750b6273073: 'Benefit/Error.GUID.2349a3fec05b081e10091750b6273073',
	GUID_d592d1bc82ea498e8f8ae00ab493ab68:
		'CandidateAccess.Login.SelfRegistration/Error.GUID.d592d1bc82ea498e8f8ae00ab493ab68',
	GUID_30177188a31a4f5d9918100f7f28fda8:
		'CandidateAccess.Login.SelfRegistration/Error.GUID.30177188a31a4f5d9918100f7f28fda8',
	GUID_ef67892b75f6e67a49330e15ab7416f7:
		'CandidateAccess.Login.SelfRegistration/Error.GUID.ef67892b75f6e67a49330e15ab7416f7',
	GUID_3041fd8982e4880be3947e575de6d932:
		'Credential.ElectronicCertificate.PublicDownload/Public.Ecertificate.Search.Error.GUID.3041fd8982e4880be3947e575de6d932',
	GUID_53dc701a18074dfe88f5a9f0fc460a11:
		'CandidateAccess.Integration.Ingress/SSO.Content.InvalidAssertion',
	GUID_d1c09d65794a4dbea930f79fa7ac3b9d:
		'CandidateAccess.Login.SelfRegistration/Error.GUID.d1c09d65794a4dbea930f79fa7ac3b9d',
};
